import { Navigate } from 'react-router-dom'
import { useGetOrg } from 'src/utils/hooks/use-get-org'
import useFeatureToggle, { Features } from 'src/utils/hooks/use-feature-toggle'
import { POSTFIX, useDocumentTitle } from 'src/utils/hooks/use-title'
import { Tier } from 'src/utils/subscription'

import StandardFlow from './flow-standard/standard.flow'

export default function UniCreate() {
  useDocumentTitle(`Create Project - ${POSTFIX}`)

  const { isLoading } = useFeatureToggle(Features.DATA_DISTRO)
  const getOrg = useGetOrg()
  const orgTier = getOrg?.data?.getOrganization?.subscription?.tier as Tier | undefined
  const isIndividual = orgTier === Tier.INDIVIDUAL || orgTier === Tier.INDIVIDUAL_TRIAL

  if (isLoading || !getOrg?.data) {
    return null
  }

  if (isIndividual) {
    return <Navigate to='/' replace />
  }

  return <StandardFlow />
}

/* WIP, finish after react-router 6.4 upgrade and move to "data APIs" (createBrowserRouter) */
/* AND/OR serialize and save state to localStorage so we can restore where they left off */
/* 
<BasicModal
  title='Are you sure you want to leave?'
  isOpen={blocker.state === 'blocked'}
  onClose={() => {
    blocker.reset()
  }}
  buttons={
    <div className='flex gap-2'>
      <Button kind={'secondary'} onClick={() => blocker.reset()}>
        Cancel
      </Button>
      <Button
        kind={'primary'}
        onClick={() => {
          blocker.proceed()
        }}
      >
        Yes, I'd like to leave
      </Button>
    </div>
  }
>
  <p>You have unsaved changes. Are you sure you want to leave?</p>
</BasicModal> 
*/
